import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="section-padding bg-background-100">
      <div className="section-container">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10 md:mb-14">
          焦点专题
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {/* First item - spans 2 cols on lg */}
          <div className="sm:col-span-2 lg:col-span-2 group cursor-pointer">
            <div className="relative rounded-2xl overflow-hidden h-64 md:h-80 border border-background-200/70">
              <img
                src={carouselItems[0].image}
                alt={carouselItems[0].title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-[10px] font-bold mb-2 whitespace-nowrap">
                  {carouselItems[0].tag}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-white">
                  {carouselItems[0].title}
                </h3>
                <p className="mt-1.5 text-sm text-white/80">{carouselItems[0].description}</p>
                <span className="inline-block mt-2 text-xs text-white/60">{carouselItems[0].count}</span>
              </div>
            </div>
          </div>

          {/* Rest */}
          {carouselItems.slice(1).map((item, i) => (
            <div key={i + 1} className="group cursor-pointer">
              <div className="relative rounded-2xl overflow-hidden h-64 md:h-80 border border-background-200/70">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[10px] font-bold mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="text-base md:text-lg font-heading font-bold text-white line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs text-white/80 line-clamp-1">{item.description}</p>
                  <span className="inline-block mt-1.5 text-xs text-white/60">{item.count}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}